import React from "react";

interface PaymentWarningBarProps {
  clientId: string;
}

const EXEMPT_CLIENT_IDS = ["519", "552"];
const DEADLINE_DATE = new Date("2026-01-17T00:00:00"); // January 17, 2026 at midnight (day after Friday the 16th)

const PaymentWarningBar: React.FC<PaymentWarningBarProps> = ({ clientId }) => {
  // Don't show the warning bar for exempt clients
  if (EXEMPT_CLIENT_IDS.includes(clientId)) {
    return null;
  }

  // Don't show the warning bar after the deadline has passed
  const currentDate = new Date();
  if (currentDate >= DEADLINE_DATE) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "#f78f03",
        color: "#000000",
        padding: "12px 20px",
        textAlign: "center",
        fontWeight: 600,
        fontSize: "14px",
        width: "100%",
        zIndex: 9999,
        position: "fixed",
        top: 0,
        left: 0,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      ⚠️ Atención: Debido a la falta de respuesta para el pago, le informamos
      que el 16 de enero nuestro servicio será suspendido, le invitamos a
      ponerse al corriente. Gracias.
    </div>
  );
};

export default PaymentWarningBar;
